/**
 * Renders a cart item's selected variant attributes inline, e.g.
 * "RAM: 32gb · Width: 14 inches · color: ●".
 *
 * `colorCode` is shown with the readable label "color" and rendered as a
 * colored swatch (the dot) rather than its raw hex value. A human-readable
 * `colorName` — when present on the variation — is kept as the swatch's
 * hover tooltip and excluded from the text list so it isn't double-shown.
 *
 * @param {Object|null|undefined} variation - The item's `selectedVariation` object.
 * @param {string} [className] - Extra classes for the wrapping <p> (e.g. spacing).
 */
export const VariationAttributes = ({ variation, className = '' }) => {
  if (!variation) return null;

  const parts = Object.entries(variation)
    .filter(([key]) => key.toLowerCase() !== 'colorname')
    .map(([key, value]) =>
      key.toLowerCase() === 'colorcode'
        ? { type: 'color', value }
        : { type: 'text', label: `${key}: ${value}` }
    );

  if (parts.length === 0) return null;

  return (
    <p
      className={`text-xs text-[#6B6B6B] flex items-center flex-wrap gap-x-1.5 ${className}`}
    >
      {parts.map((part, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && <span aria-hidden>·</span>}
          {part.type === 'color' ? (
            <>
              color:
              <span
                className="inline-block w-3 h-3 rounded-full border border-[#DADADA] shrink-0"
                style={{ backgroundColor: part.value }}
                title={variation.colorName || part.value}
              />
            </>
          ) : (
            part.label
          )}
        </span>
      ))}
    </p>
  );
};
